const GROUP_TAGS_ORGANIZATION = {
  CONTRACT_ANALYSIS: 'contract_analysis_group',
  LEGAL_FRAMEWORK: 'legal_framework_group',
  WRITING_ASSISTANT: 'writing_assistant_group',
  LEGAL_REQUESTS: 'legal_requests_group',
}

const GROUP_TAGS_COMPANY = {
  GOVERNANCE_PROJECTS: 'governance_projects_group',
}

const GROUP_TAGS = {
  ORGANIZATION: GROUP_TAGS_ORGANIZATION,
  COMPANY: GROUP_TAGS_COMPANY,
}

const TAGS_ORGANIZATION = {
  LEGAL_FRAMEWORK: 'legal_framework',
  LEGAL_GENERATIVE: 'legal_generative',
  SECURITY_GENERATIVE: 'security_generative',
  TICKET_VALIDATION: 'ticket_validation',
  TICKET_WRITER_ASSISTANT: 'ticket_writer_assistant',
  GRAMMAR_ASSISTANT: 'grammar_assistant',
  CONTRACT_ANALYSIS: 'contract_analysis',
  CONTRACT_EXTRACTION: 'contract_extraction',
  CONTRACT_GENERAL_INFORMATION: 'contract_general_information',
  CONTRACT_CLASSIFICATION: 'contract_classification',
  CONTRACT_JUDGMENT: 'contract_judgment',
}

const TAGS_COMPANY = {
  DAI_CHAT_PLATFORM: 'dai_chat_platform',
  GENERATE_PLAN_ACTION: 'generate_plan_action',
  GOVERNANCE_PROJECT_ACTIVITY_ANALYSIS: 'governance_project_activity_analysis',
  GOVERNANCE_PROJECT_EVIDENCE_ANALYSIS: 'governance_project_evidence_analysis',
  GOVERNANCE_PROJECT_EVIDENCE_SOA_ANALYSIS:
    'governance_project_evidence_soa_analysis',
  DISPUTE_ANALYSIS: 'dispute_analysis',
  PRE_CONTRACT_ANALYSIS: 'pre_contract_analysis',
  POP_CREATION: 'pop_creation',
  DOCUMENT_CREATION: 'document_creation',
}

const TAGS = {
  ORGANIZATION: TAGS_ORGANIZATION,
  COMPANY: TAGS_COMPANY,
}

const STATUSES = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
}

const OWNED_BY = {
  COLLABORATOR: 'collaborator',
  ORGANIZATION: 'organization',
  COMPANY: 'company',
}

const GROUP_MANAGEABLE = {
  UNIFIED: 'unified',
  PER_SOLUTION: 'per_solution',
}

const SOLUTION_MANAGEABLE = {
  INDIVIDUAL: 'individual',
  GROUP_ONLY: 'group_only',
}

const solutions = {
  GROUP_TAGS_ORGANIZATION,
  GROUP_TAGS_COMPANY,
  GROUP_TAGS,
  TAGS_ORGANIZATION,
  TAGS_COMPANY,
  TAGS,
  STATUSES,
  OWNED_BY,
  GROUP_MANAGEABLE,
  SOLUTION_MANAGEABLE,
}

export default solutions
